(function () {
  'use strict';

  var STORAGE_KEY = 'yv:welcome-popup-seen';
  var DELAY_MS = 12000;
  var COPIED_RESET_MS = 1600;
  var CLOSE_TRANSITION_MS = 280;

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (_) { return null; }
  }
  function safeSet(key, value) {
    try { localStorage.setItem(key, value); } catch (_) { /* noop */ }
  }

  if (safeGet(STORAGE_KEY)) return;

  var popup = null;
  var openTimer = null;
  var opened = false;

  function init() {
    popup = document.querySelector('[data-yv-welcome-popup]');
    if (!popup) return;

    openTimer = window.setTimeout(open, DELAY_MS);

    var closeBtn = popup.querySelector('[data-yv-welcome-close]');
    if (closeBtn) closeBtn.addEventListener('click', dismiss);

    var form = popup.querySelector('form');
    if (form) form.addEventListener('submit', onSubmit);

    var copyBtn = popup.querySelector('[data-yv-welcome-copy]');
    if (copyBtn) copyBtn.addEventListener('click', onCopy);

    document.addEventListener('keydown', onKeydown);
  }

  function open() {
    if (!popup || opened) return;
    opened = true;
    popup.hidden = false;
    void popup.offsetWidth; // force reflow so transition runs
    popup.classList.add('is-open');
  }

  function close() {
    if (!popup) return;
    popup.classList.remove('is-open');
    window.setTimeout(function () { popup.hidden = true; }, CLOSE_TRANSITION_MS);
  }

  function dismiss() {
    safeSet(STORAGE_KEY, '1');
    if (openTimer) { window.clearTimeout(openTimer); openTimer = null; }
    close();
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    if (!popup || popup.hidden || !popup.classList.contains('is-open')) return;
    dismiss();
  }

  function showError(msg) {
    var el = popup.querySelector('[data-yv-welcome-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function clearError() {
    var el = popup.querySelector('[data-yv-welcome-error]');
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  function showSuccess() {
    var def = popup.querySelector('[data-yv-welcome-state="default"]');
    var suc = popup.querySelector('[data-yv-welcome-state="success"]');
    if (def) def.hidden = true;
    if (suc) suc.hidden = false;
  }

  function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    clearError();

    var form = e.currentTarget;
    var emailInput = form.querySelector('input[name="contact[email]"]');
    var email = (emailInput && emailInput.value || '').trim();

    if (!/.+@.+\..+/.test(email)) {
      showError('Please enter a valid email.');
      return;
    }

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch('/contact#contact_form', {
      method: 'POST',
      body: new FormData(form),
    })
      .then(function () {
        safeSet(STORAGE_KEY, '1');
        showSuccess();
      })
      .catch(function () {
        showError('Something went wrong. Please try again.');
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function copyFallback(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (_) { /* noop */ }
    document.body.removeChild(ta);
  }

  function onCopy(e) {
    var btn = e.currentTarget;
    var codeEl = popup.querySelector('[data-yv-welcome-code]');
    var code = (codeEl && codeEl.textContent || 'YVSEFI10').trim();
    var original = btn.textContent;

    function flashCopied() {
      btn.textContent = 'Copied ✓';
      window.setTimeout(function () { btn.textContent = original; }, COPIED_RESET_MS);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(flashCopied).catch(function () {
        copyFallback(code);
        flashCopied();
      });
    } else {
      copyFallback(code);
      flashCopied();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
